import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    list: [],
    meta: {},
  },
  mutations: {
    SET_LIST(state, data) {
      state.list = data.list;
      state.meta = data.meta;
    },
    DELETE_REQUEST(state, id) {
      state.list = state.list.filter((item) => item.id !== id);
    },
  },
  actions: {
    async get({ commit }, page) {
      const { payload } = await $http.get(
        `company-admin/solar-request?page=${page}`
      );
      commit("SET_LIST", {
        list: payload.data,
        meta: payload.meta,
      });
    },
    async delete({ commit }, id) {
      await $http.delete(`company-admin/solar-request/${id}`);
      commit("DELETE_REQUEST", id);
    },
  },
};
